import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { UploaderMethodProps, UploadResultType } from 'src/app/shared/components/imageUpload';

export type ImageData = NonNullable<NonNullable<UploadResultType>['successful']>[number];

type Uploader = UploaderMethodProps;

// eslint-disable-next-line complexity
export async function uploadImage(
	uploader: Uploader,
	image: string,
	utilityContext: UtilityContext,
): Promise<ImageData> {
	try {
		if (!image) throw new Error('No image URL provided');

		// Check if there are already files before adding a new one
		if (uploader.getFile() === undefined) {
			await uploader.addFileAsync(image);
		}

		uploader.onFileAdded(() => {});
		uploader.onUseAwsS3(utilityContext, 'USER_UPLOADS');

		const result = await uploader.upload();

		if ((result?.failed?.length ?? 0) > 0) {
			throw new Error(result?.failed?.[0]?.error ?? 'Upload failed');
		}

		if (!result?.successful?.[0]?.uploadURL) {
			throw new Error('Bad URL returned from upload');
		}

		return result.successful[0];
	} catch (e: unknown) {
		const message = e instanceof Error ? e.message : 'Unexpected error';
		throw new Error(message, { cause: e });
	}
}
